import Api from "app/services/common/Api";
import {PstatModel} from "app/model/info/pstat";
import {DocuBizPlnd} from "app/model/cp/DocuBizPlnd";
import {DbUserConfigModel} from "app/model/db/dbUserConfigModel";
import { TrdStatusModel } from "app/model/ot/octModel";
import {ApiUrlUtil} from "app/utils/apiUrlUtil";
import axios from "axios";
import {HeadersUtil} from "app/utils/headersUtil";

export class DbUserService extends Api {
  private static service: DbUserService;
  public static getInstance(): DbUserService {
    if (!DbUserService.service) {
      DbUserService.service = new DbUserService();
    }
    return DbUserService.service;
  }

  private readonly coApiPowerGen = process.env.REACT_APP_URL_CO + '/mg/power/generation';
  private readonly wpApi = process.env.REACT_APP_URL_WP + '';
  private readonly cpApi = process.env.REACT_APP_URL_CP + '';
  private readonly coApi = process.env.REACT_APP_URL_CO + '';
  private readonly rpApi = process.env.REACT_APP_URL_RP + '';
  private readonly otApi = process.env.REACT_APP_URL_OT + '';

  public async fetchDashboardList() {
    return await super.get<DbUserConfigModel[]>(this.coApi + '/dashboard/list');
  }

  public async fetchUserConfigList() {
    return await super.get<DbUserConfigModel[]>(this.coApi + '/dashboard/config');
  }

  public async saveUserConfigList(param: { dshbdIds: string[] }) {
    return await super.post<DbUserConfigModel[]>(this.coApi + '/dashboard/config', param);
  }

  // 사용자 대시보드 > 전력 > 설비현황
  public async fetchInverterEfficiency(page: number) {
    const url = ApiUrlUtil.buildQueryString(
        process.env.REACT_APP_URL_CO + `/pc/facility/status/pv?page=${page}&perPage=3`
    );
    return await axios.get(url, {
      headers: HeadersUtil.getHeaders(),
    });
  }

  // 사용자 대시보드 > 전력 > 공급현황
  public async fetchPowerSupplyInfo() {
    return await super.get<any>(this.coApi + '/db/power/supply');
  }

  // 사용자 대시보드 > 전력 > 소비현황
  public async fetchPowerConsumeInfo() {
    return await super.get<any>(this.coApi + '/db/power/consume');
  }

  // 사용자 대시보드 > 전력 > 일발전량
  public async fetchPvDayData() {
    return await super.get<any>(this.coApi + '/db/power/pv/day');
  }

  // 사용자 대시보드 > 전력 > 일반전량 > 금일 공급시간
  public async fetchPvDayDataTime() {
    return await super.get<any>(this.coApi + '/dcgrid/sply/time/day');
  }

  // 사용자 대시보드 > 전력 > 월발전량
  public async fetchPvMonthData() {
    return await super.get<any>(this.coApi + '/db/power/pv/month');
  }

  // 사용자 대시보드 > 전력 > 월발전량 > 월 평균 공급시간
  public async fetchPvMonthDataTime() {
    return await super.get<any>(this.coApi + '/dcgrid/sply/time/month');
  }

  // 사용자 대시보드 > 전력 > ESS현황
  public async fetchLoadData() {
    return await super.get<any>(this.coApi + '/db/power/load');
  }

  // 사용자 대시보드 > 전력 > ESS현황
  public async fetchEssData() {
    return await super.get<any>(this.coApi + '/db/power/ess');
  }

  public async fetchRealTimePowerGen(date: string) {
    return await super.get<any>(this.coApiPowerGen + '/hour', {fromDt: date});
  }

  public async fetchDayPowerGen(date: string) {
    return await super.get<any>(this.coApiPowerGen + '/day', {fromDt: date});
  }

  public async fetchRecentNotice() {
    return await super.get<PstatModel[]>(this.wpApi + '/pstat/notice/recent');
  }

  public async fetchCpBizplnd() {
    return await super.get<DocuBizPlnd[]>(this.cpApi + '/bizplnd/select');
  }

  public async fetchLatestEvents() {
    return await super.get<any[]>(this.coApi + '/mg/events/latest');
  }

  public async getPPATrdCnt() {
    return await super.get<any>(this.rpApi + '/ppa-rqs/trdByUser');
  }
  public async getRECTrdCnt() {
    return await super.get<TrdStatusModel>(this.otApi + '/db/status/rec', {thisYear: true});
  }
  public async getEMSTrdCnt() {
    return await super.get<TrdStatusModel>(this.otApi + '/db/status/emission', {thisYear: true});
  }

  public async getMonthlyQnt(year: string) {
    return await super.get<any>(this.rpApi + '/smcnCert/monthlyQnt', {year: year});
  }

  /**
   * @description smcnCert 이행수단 실적 사용 및 수정 완료 2025.08.06
   */
  public async getGoalInfo() {
    return await super.get<any>(this.rpApi + '/rdmp/goalPfrc');
  }

  public async fetchRlibr() {
    return await super.get<PstatModel[]>(this.rpApi + '/rlibr/recent');
  }

}